import { z } from 'zod'

export const wireDateSchema = z.union([z.string(), z.number()])
export type WireDate = z.infer<typeof wireDateSchema>

const SECONDS_TO_MS_THRESHOLD = 1e11

export const parseWireDate = (value: string | number | null | undefined): Date | null => {
  if (value === null || value === undefined || value === '') return null

  if (typeof value === 'string' && !/^-?\d+$/.test(value.trim())) {
    const iso = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(value) ? value : `${value}Z`
    const fromIso = new Date(iso)
    return Number.isNaN(fromIso.getTime()) ? null : fromIso
  }

  const epoch = Number(value)
  const ms = Math.abs(epoch) < SECONDS_TO_MS_THRESHOLD ? epoch * 1000 : epoch
  const fromEpoch = new Date(ms)
  return Number.isNaN(fromEpoch.getTime()) ? null : fromEpoch
}

export const wireDateToEpochMs = (value: WireDate | null | undefined): number | undefined =>
  parseWireDate(value)?.getTime()

const CALENDAR_DAY_SHAPE = /^\d{4}-\d{2}-\d{2}$/

const calendarDaySchema = z.iso.date()

const calendarDayToEpochMs = (day: string): number | undefined =>
  calendarDaySchema.safeParse(day).success ? Date.parse(`${day}T12:00:00Z`) : undefined

export const wireDateOrDayToEpochMs = (value: WireDate | null | undefined): number | undefined =>
  typeof value === 'string' && CALENDAR_DAY_SHAPE.test(value) ? calendarDayToEpochMs(value) : wireDateToEpochMs(value)
